import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import theme from './theme'

/**
 * Wraps the application with the MUI theme + CssBaseline reset.
 *
 * Kept as a standalone composable component (rather than being wired
 * directly into `client/src/main.jsx`) because tasks 002 (router) and 003
 * (TanStack Query) are concurrently changing the render tree in
 * `main.jsx`. Once those land, `main.jsx` should wrap its tree with this
 * provider, e.g.:
 *
 *   <AppThemeProvider>
 *     <AppProviders>
 *       <AppRoutes />
 *     </AppProviders>
 *   </AppThemeProvider>
 *
 * `prop-types` isn't a project dependency (see `RoutePlaceholder.jsx` /
 * `AppProviders.jsx` for the same rationale), so `react/prop-types` is
 * disabled here rather than pulling in a new dependency.
 */
// eslint-disable-next-line react/prop-types
function AppThemeProvider({ children }) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  )
}

export default AppThemeProvider
